(() => {
  const container = document.getElementById('ProductGridContainer');
  if (!container || !window.location.pathname.includes('/collections/')) return;
  const cache = new Map();
  let activeController;
  async function orderGrid() {
    const grid = container.querySelector('[data-crispy-available-first]');
    if (!grid || grid.dataset.crispyOrdered) return;
    grid.dataset.crispyOrdered = 'pending';
    activeController?.abort();
    const controller = new AbortController();
    activeController = controller;
    const params = new URLSearchParams(window.location.search);
    const availability = params.getAll('filter.v.availability').flatMap(value => value.split(','));
    if (availability.length && new Set(availability).size === 1) {
      grid.dataset.crispyOrdered = 'done';
      return;
    }
    const total = Number(grid.dataset.crispyTotal);
    const size = Number(grid.dataset.crispyPageSize);
    const page = Number(grid.dataset.crispyPage);
    if (!total || !size || !page) return;
    params.delete('page');
    params.delete('filter.v.availability');
    params.set('section_id', grid.dataset.id);
    grid.setAttribute('aria-busy', 'true');
    const timer = window.setTimeout(() => controller.abort(), 90000);
    async function getPage(available, number) {
      const requestParams = new URLSearchParams(params);
      requestParams.set('filter.v.availability', String(available));
      requestParams.set('page', String(number));
      const url = window.location.pathname + '?' + requestParams;
      if (!cache.has(url)) {
        const request = fetch(url, { signal: controller.signal }).then(async response => {
          if (!response.ok) throw new Error('Collection request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = doc.querySelector('[data-crispy-available-first]');
          if (!result) {
            if (doc.querySelector('#ProductGridContainer .collection--empty')) return { count: 0, cards: [] };
            throw new Error('Collection grid missing');
          }
          return { count: Number(result.dataset.crispyTotal), cards: Array.from(result.children) };
        }).catch(error => { cache.delete(url); throw error; });
        cache.set(url, request);
        if (cache.size > 64) cache.delete(cache.keys().next().value);
      }
      return cache.get(url);
    }
    async function range(available, start, length) {
      if (!length) return [];
      const first = Math.floor(start / size) + 1;
      const last = Math.floor((start + length - 1) / size) + 1;
      const responses = await Promise.all(Array.from({ length: last - first + 1 }, (_, index) => getPage(available, first + index)));
      const offset = start % size;
      return responses.flatMap(result => result.cards).slice(offset, offset + length);
    }
    try {
      const availableCount = (await getPage(1, 1)).count;
      const start = (page - 1) * size;
      const expected = Math.min(size, total - start);
      const availableLength = Math.max(0, Math.min(size, availableCount - start));
      const soldStart = Math.max(0, start - availableCount);
      const soldLength = expected - availableLength;
      const groups = await Promise.all([range(1, start, availableLength), range(0, soldStart, soldLength)]);
      const cards = groups.flat();
      if (cards.length !== expected) throw new Error('Collection count changed');
      if (controller.signal.aborted || !grid.isConnected || container.querySelector('[data-crispy-available-first]') !== grid) return;
      cards.forEach((card, index) => {
        card.style.setProperty('--animation-order', index + 1);
        card.classList.add('scroll-trigger--cancel');
      });
      grid.replaceChildren(...cards);
      grid.dataset.crispyOrdered = 'done';
    } catch (error) {
      grid.dataset.crispyOrdered = 'fallback';
      if (error.name !== 'AbortError') console.warn('Crispy collection ordering:', error.message);
    } finally {
      window.clearTimeout(timer);
      grid.style.visibility = '';
      grid.removeAttribute('aria-busy');
    }
  }
  new MutationObserver(orderGrid).observe(container, { childList: true });
  orderGrid();
})();

